// extracted by mini-css-extract-plugin
export default {"tickerContainer":"NewsTicker_tickerContainer__jL+z9","dragging":"NewsTicker_dragging__MG0fq","tickerContent":"NewsTicker_tickerContent__oIHNk"};